import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: []
})
export class LayoutsComponent implements OnInit {

  constructor() {}
  ngOnInit(): void {
      }
}
